export default __webpack_public_path__ + "static/participate1-e0daa62c9dd0f9bbaae28fdcb0ef6103.png";